/**
 * Indicates if the order is currently being worked. Applicable only for OrdStatus = "New". For open outcry markets this indicates that the order is being worked in the crowd. For electronic markets it indicates that the order has transitioned from a contingent order to a market order.
 * - Tag: 636
 * - FIX Specification type: Boolean
 * - Mapped type: string
 * @readonly
 * @public
 */
export const WorkingIndicator = Object.freeze({
    /** Order has been accepted but not yet in a working state */
    NotWorking: 'N',
    /** Order is currently being worked */
    Working: 'Y',
} as const);

export type WorkingIndicator = (typeof WorkingIndicator)[keyof typeof WorkingIndicator];
